import { render, staticRenderFns } from "./FormatSetTreeEditor.vue?vue&type=template&id=0d37c36a&scoped=true&"
import script from "./FormatSetTreeEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatSetTreeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatSetTreeEditor.vue?vue&type=style&index=0&id=0d37c36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37c36a",
  null
  
)

export default component.exports